import PropTypes from 'prop-types'

import { Span, Currency, LeaseTerm, PropertyType, List } from 'components'
import { COLOR } from 'styles/constants'

import { ListWrapper, ItemWrapper } from './styled'

export const LeasingInformation: React.FC<ILeasingInformation> = ({
  rentAmount,
  dateAvailable,
  listingId,
  securityDeposit,
  term,
  propertyType,
  termAmountOfMonths,
}: ILeasingInformation) => (
  <>
    <ListWrapper>
      <List<ILeasingInformationDataSource>
        dataSource={[
          {
            key: 'Monthly Rent:',
            value: rentAmount,
            component: (value: LeasingInformationValue) => (
              <Currency $color={COLOR.GREY_LV1} data-testid="rentAmount" value={value as number} />
            ),
          },
          {
            key: 'Security Deposit:',
            value: securityDeposit,
            component: (value: LeasingInformationValue) => (
              <Currency
                $color={COLOR.GREY_LV1}
                data-testid="securityDeposit"
                value={value as number}
              />
            ),
          },
          {
            key: 'Date Available:',
            value: dateAvailable,
            component: (value: LeasingInformationValue) => (
              <Span $color={COLOR.GREY_LV1} data-testid="dateAvailable">
                {value}
              </Span>
            ),
          },
          {
            key: 'Lease Term:',
            value: { term, termAmountOfMonths },
            component: (value: LeasingInformationValue) => {
              const { term: componentTerm, termAmountOfMonths: componentTermAmountOfMOnth } =
                value as ILeaseTerm
              return (
                <LeaseTerm
                  $color={COLOR.GREY_LV1}
                  term={componentTerm}
                  termAmountOfMonths={componentTermAmountOfMOnth}
                  data-testid="term"
                />
              )
            },
          },
          {
            key: 'Listing ID:',
            value: listingId,
            component: (value: LeasingInformationValue) => (
              <Span $color={COLOR.GREY_LV1} data-testid="listingId">
                {value}
              </Span>
            ),
          },
          {
            key: 'Property Type:',
            value: propertyType,
            component: (value: LeasingInformationValue) => (
              <PropertyType
                $color={COLOR.GREY_LV1}
                type={value as PropertyType}
                data-testid="propertyType"
              />
            ),
          },
        ]}
        renderItem={({ value, key, component }: ILeasingInformationDataSource) => {
          const Component = component(value)
          return (
            <ItemWrapper key={key}>
              <Span $weight="600"> {key} </Span>
              {Component}
            </ItemWrapper>
          )
        }}
      />
    </ListWrapper>
  </>
)

LeasingInformation.defaultProps = {
  termAmountOfMonths: 1,
}

LeasingInformation.propTypes = {
  rentAmount: PropTypes.number.isRequired,
  dateAvailable: PropTypes.string.isRequired,
  listingId: PropTypes.string.isRequired,
  securityDeposit: PropTypes.number.isRequired,
  term: PropTypes.oneOf<LeaseTerm>(['AMOUNT_OF_MONTHS', 'MONTHLY', 'YEARLY']).isRequired,
  propertyType: PropTypes.oneOf<PropertyType>([
    'N/A',
    'SINGLE_FAMILY_HOME',
    'MULTI_FAMILY_HOME',
    'CONDOMINIUM',
    'APARTMENT',
    'MANUFACTURED_HOME',
    'TOWNHOUSE',
    'STUDENT_HOUSING',
    'OTHERS',
  ]).isRequired,
  termAmountOfMonths: PropTypes.number,
}
